import type {
  AppointmentConfigJsonType,
  EnhancedAppointment,
  IListing,
  OfferSettingsJsonType,
} from '@bb/domain/dist/types';
import type { GetExternalConfig } from '@bb/domain/dist/types/dto/AppointmentController/getExternalConfig';
import Axios from 'axios';
import type LastPhoneNumber from '@bb/domain/dist/types/LastPhoneNumber';
import type { getListing } from '../ListingController';

// TODO: will be replaced by @/app-package package
type AppointmentBookingInfoType = {
  appointmentConfig: AppointmentConfigJsonType;
  externalConfig: GetExternalConfig &
    Pick<
      AppointmentConfigJsonType,
      | 'advAutoConfEnabled'
      | 'days'
      | 'specialTimes'
      | 'notice'
      | 'noticeMinutes'
    >;
  offerDetails: {
    offerSettings: OfferSettingsJsonType;
    offerSubmissions: string;
    offerCount: number;
  };
  unavailableDays: { days: string[]; after?: Date };
  phoneNumber: LastPhoneNumber | null;
  portalAssocData?: {
    id: string;
    defaultOneDayCodeEnabled: boolean;
    cancelOnPending: boolean | null;
    narSettlementCommission: boolean | null;
    narSettlementAgreement: boolean | null;
    quickAccess: boolean | null;
    hideMemberId: boolean | null;
  };
  listing: Awaited<ReturnType<typeof getListing>>;
  blockedAppointments: {
    listing: IListing;
    appointment: EnhancedAppointment;
  }[];
};

const getAppointmentBookingInfo = async (listingId: string) => {
  const { data } = await Axios.get<AppointmentBookingInfoType>(
    `/listing/${listingId}/appointment_booking_info`,
  );
  return data;
};

export default getAppointmentBookingInfo;
